// src/components/MemoriesModal.jsx
import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";

export default function MemoriesModal({ user, closeModal }) {
  const [memories, setMemories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    async function fetchMemories() {
      setLoading(true);
      const { data, error } = await supabase
        .from("user_memories")
        .select("*")
        .eq("user_id", user.id);
      if (error) {
        setError(error.message);
      } else {
        setMemories(data);
      }
      setLoading(false);
    }
    fetchMemories();
  }, [user]);

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      {/* Modal backdrop */}
      <div className="absolute inset-0 bg-gray-900 opacity-50" onClick={closeModal}></div>
      {/* Modal content */}
      <div className="bg-white rounded-lg p-6 relative max-w-lg w-full z-10">
        <h2 className="text-xl font-bold mb-4">Memories</h2>
        {loading ? (
          <p>Loading memories...</p>
        ) : error ? (
          <p>Error: {error}</p>
        ) : memories.length > 0 ? (
          <ul className="overflow-y-auto max-h-64 text-gray-800">
            {memories.map((memory) => (
              <li key={memory.id} className="border-b border-gray-200 py-2">
                <p>{memory.memory}</p>
                <span className="text-xs text-gray-500">
                  {new Date(memory.created_at).toLocaleString()}
                </span>
              </li>
            ))}
          </ul>
        ) : (
          <p>No memories found.</p>
        )}
        <button
          onClick={closeModal}
          className="mt-4 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
        >
          Close
        </button>
      </div>
    </div>
  );
}
